module.exports = __webpack_public_path__ + "static/media/Banner_Desktop-nogradient.966329f7.png";